import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { setOpacity } from "@memorang/helpers/src/setOpacity";
import React, { useEffect } from "react";
import { Animated, Easing } from "react-native";
import { useAppTheme } from "../../../useAppTheme";
import Box from "../../Box";
import MarkdownText from "../MarkdownText";

export type Props = {
	text: string;
};

const AttemptingConnectionMessage = ({ text }: Props) => {
	const theme = useAppTheme();
	const spinValue = React.useRef(new Animated.Value(0)).current;
	useEffect(() => {
		const animation = Animated.loop(
			Animated.sequence([
				Animated.timing(spinValue, {
					toValue: 1,
					easing: Easing.linear,
					duration: 1500,
					useNativeDriver: true,
				}),
				Animated.timing(spinValue, {
					toValue: 0,
					duration: 0,
					useNativeDriver: true,
				}),
			]),
		);

		animation.start();

		return () => {
			animation.stop();
		};
	}, [spinValue]);
	return (
		<Box
			flexDirection="row"
			gap={8}
			backgroundColor={theme.colors.surfaceContainer}
			borderWidth={1}
			borderColor={setOpacity(theme.colors.outline, 0.16)}
			alignItems="center"
			borderRadius={100}
			padding={12}
		>
			<Animated.View
				style={{
					transform: [
						{
							rotate: spinValue.interpolate({
								inputRange: [0, 1],
								outputRange: ["0deg", "360deg"],
							}),
						},
					],
				}}
			>
				<Icon
					name="vanish"
					size={20}
					color={theme.colors.onSecondaryContainer}
				/>
			</Animated.View>
			<MarkdownText
				text={text}
				variant="explanation"
				style={{ color: theme.colors.onSecondaryContainer }}
			/>
		</Box>
	);
};

export default AttemptingConnectionMessage;
